import { useTranslation } from 'react-i18next';

import { DotRadio } from '../questions/dotRadio/DotRadio';
import { GadHeaderRow } from '../questions/dotRadio/GadHeaderRow';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function Energy2({
  active,
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onSetValue,
}: AssessmentPageItem) {
  const { t } = useTranslation();
  const headerText = [
    { key: 0, value: t('radioOption.never') },
    { key: 1, value: t('radioOption.rarely') },
    { key: 2, value: t('radioOption.sometimes') },
    { key: 3, value: t('radioOption.often') },
    { key: 4, value: t('radioOption.always') },
  ];
  const radioOptions = [
    t('radioOption.never'),
    t('radioOption.rarely'),
    t('radioOption.sometimes'),
    t('radioOption.often'),
    t('radioOption.always'),
  ];
  return (
    <div className={`question_container ${active}`} id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>

      <fieldset className="question_block_wide gad" data-input-type="energy_work">
        <legend className="assessment_question_title" id="energy_work">
          {t('A107')}
        </legend>
        <div className="answer_block">
          <GadHeaderRow headerText={headerText} />
          <DotRadio
            questionid="respected_work"
            range="5"
            width=""
            questionTitle={t('assessment.question.respected_work')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="energy_work"
          />
          <DotRadio
            questionid="supported_work"
            range="5"
            width=""
            questionTitle={t('assessment.question.supported_work')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="energy_work"
          />
          <DotRadio
            questionid="trusted_work"
            range="5"
            width=""
            questionTitle={t('assessment.question.trusted_work')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="energy_work"
          />
          <DotRadio
            questionid="listened_work"
            range="5"
            width=""
            questionTitle={t('assessment.question.listened_work')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="energy_work"
          />
          <DotRadio
            questionid="part_of_team_work"
            range="5"
            width=""
            questionTitle={t('assessment.question.part_of_team_work')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="energy_work"
          />
        </div>
      </fieldset>
    </div>
  );
}
